import { GetFullUserType } from '@orbit/api-types'
import api from '@lib/api'
import { queryKeys } from '@lib/queryKeys'
import { useQuery } from '@tanstack/react-query'

/** My profile. `enabled` holds it back for a signed-out visitor on a public page. */
export const useMe = ({ enabled = true }: { enabled?: boolean } = {}) => {
	return useQuery<GetFullUserType>({
		queryKey: queryKeys.me(),
		queryFn: async () => {
			const response = await api.get<GetFullUserType>('/users')
			return response.data
		},
		retry: 1,
		enabled,
	})
}

